export const ASSESSMENT_OPTIONS = ["ALL", "ATLAS", "DELV", "WRA"] as const;
export type AssessmentName = typeof ASSESSMENT_OPTIONS[number];

export const ASSESSMENT_SCHEMA_IDS: Partial<Record<AssessmentName, number>> = {
  ALL: 2,
  DELV: 1,
  WRA: 3,
};

export const assessmentAccessForUser = (user: any): AssessmentName[] => {
  const configured = Array.isArray(user?.assessment_access) ? user.assessment_access : ["WRA"];
  return ASSESSMENT_OPTIONS.filter((assessment) => configured.includes(assessment));
};

export const launchableAssessmentsForUser = (user: any) =>
  assessmentAccessForUser(user)
    .filter((assessment) => ASSESSMENT_SCHEMA_IDS[assessment] !== undefined)
    .map((assessment) => ({
      name: assessment,
      schemaId: ASSESSMENT_SCHEMA_IDS[assessment] as number,
    }));

export const userHasResultsAccess = (user: any) =>
  assessmentAccessForUser(user).some((assessment) => assessment === "WRA" || assessment === "ATLAS");

export const testDestination = (test: any) =>
  `/test/${encodeURIComponent(test.name)}/${encodeURIComponent(test.id)}`;

export const completedTestDestination = (test: any) =>
  test.name === "ALL" || test.name === "DELV"
    ? testDestination(test)
    : `/results?students=${encodeURIComponent(test.student_id)}&test=${encodeURIComponent(test.id)}`;
